import type { ReactNode } from "react";

interface TripMetricProps {
  icon: ReactNode;
  label: string;
  value: string;
  detail?: string;
}

export function TripMetric({ icon, label, value, detail }: TripMetricProps) {
  return (
    <div className="trip-metric">
      <span className="trip-metric__icon" aria-hidden="true">
        {icon}
      </span>
      <span className="trip-metric__copy">
        <span className="trip-metric__label">{label}</span>
        <strong className="trip-metric__value">{value}</strong>
        {detail ? <span className="trip-metric__detail">{detail}</span> : null}
      </span>
    </div>
  );
}
